import {getShopId} from '../utils/auth';
import {get} from './httpApi';

/*名兰文章列表*/
export function getNewsPage(data){
    return get('/news/noJwt/newsPage',{
        ...data
    })
}
/*名兰文章列表*/
export function getNewsCelebrityPage(data){
    return get('/news/noJwt/getNewsCelebrityPage',{
        ...data
    })
}
/*获取名兰文章详情*/
export function getNewsInfoById(data){
    return get('/news/noJwt/getNewsInfoById',{
        ...data
    })
}
/*获取名人文章详情*/
export function getNewsCelebrityInfoById(data){
    return get('/news/noJwt/getNewsCelebrityInfoById',{
        ...data
    })
}
/**
 * 商家上传名兰文章
 * @param:title 标题
 * @param:desc 描述
 * @param:img 封面图片
 * @param:content 富文本内容
 * @param:ACCESS_TOKEN 令牌
 * */
export function addNewsForShop(data){
    return get('/news/addNewsForShop',{
        ...data,
        shopId:getShopId()
    })
}
